import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { useParams, useLocation } from 'react-router-dom';
import { getStationById } from '../store/reducers/fmAPI.js';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { ListGroup } from 'react-bootstrap';

import { FMUpstreamIcon, FMDownstreamIcon } from '../components/FloodMapperIcons';

import CentralLink from '../components/CentralLink.js';
import StationLinker from '../components/StationLinker.js';

import loadable from '@loadable/component';

import StationNameRenderer from '../components/StationNameRenderer.js';
import StationMetricTypeIcon from '../components/StationMetricTypeIcon.js';
import BreadcrumbComponent from '../components/BreadcrumbComponent.js';

import CommonHeaders from '../components/helmet-headers/CommonHeaders.js';
import Breadcrumbs, { CRUMBS } from '../components/helmet-headers/Breadcrumbs.js';
import GoverningBodyFlag from '../components/GoverningBodyFlag.js';

import TLDHelper from '../lib/tldHelper.js';


import { sendClickStationUpstreamButton, sendClickStationDownstreamButton } from '../components/GoogleAnalytics.js';
// import WaterLevelGauge from '../components/WaterLevelGauge.js';
// import WaterLevelLineChart from '../components/WaterLevelLineChart.js';
// import MapViewHeaderComponent from '../components/MapViewHeaderComponent.js'
// import FloodAlertSummaryComponent from '../components/FloodAlertSummaryComponent.js';
// import NearByStationsComponent from '../components/NearByStationsComponent.js';
// import FMCoverageAreas from '../components/FMCoverageAreas.js';
// import Loading from '../components/Loading.js';
// import GoverningBodyName from '../components/GoverningBodyName.js';
// import StationMapMarkerLegendComponent from '../components/StationMapMarkerLegendComponent.js';
// import StationMapMarkerComponent from '../components/StationMapMarkerComponent.js';

// import AdComponent from '../components/AdComponent.js';

// const StationNameRenderer = loadable(() => import('../components/StationNameRenderer.js'));
const MapViewHeaderComponent = loadable(() => import('../components/MapViewHeaderComponent.js'));
const MapButtonCentralLink = loadable(() => import('../components/MapButtonCentralLink.js'));
const FloodAlertSummaryComponent = loadable(() => import('../components/FloodAlertSummaryComponent.js'));
const NearByStationsComponent = loadable(() => import('../components/NearByStationsComponent.js'));
const FMCoverageAreas = loadable(() => import('../components/FMCoverageAreas.js'));
const Loading = loadable(() => import('../components/Loading.js'));
const GoverningBodyName = loadable(() => import('../components/GoverningBodyName.js'));
const Alert = loadable(() => import('react-bootstrap/Alert'));
const StationMapMarkerLegendComponent = loadable(() => import('../components/StationMapMarkerLegendComponent.js'), {
	fallback: null,
	ssr: false
});
const StationMapMarkerComponent = loadable(() => import('../components/StationMapMarkerComponent.js'), {
	fallback: null,
	ssr: false
});
const AdComponent = loadable(() => import('../components/AdComponent.js'), {fallback: null, ssr: false});
const AppStationSubscribe = loadable(() => import('../components/AppStationSubscribe.js'), { fallback: null, ssr: false });
const AppManageMetricsModal = loadable(() => import('../components/AppManageMetricsModal.js'), { fallback: null, ssr: false });

const RenderStationLevelBased = loadable(() => import('../components/station-renderers/RenderStationLevelBased.js'));
const RenderStationSewageDischarge = loadable(() => import('../components/station-renderers/RenderStationSewageDischarge.js'));
const RenderStationSewageDischargeLive = loadable(() => import('../components/station-renderers/RenderStationSewageDischargeLive.js'));
const RenderStationFlowBased = loadable(() => import('../components/station-renderers/RenderStationFlowBased.js'));
const RenderStationRainfall = loadable(() => import('../components/station-renderers/RenderStationRainfall.js'));
const RenderStationTemperatureBased = loadable(() => import('../components/station-renderers/RenderStationTemperatureBased.js'));


// const GET_STATION_SUCCESS = 'GET_STATION_SUCCESS';


function StationView(props) {
	const { t } = useTranslation();
	const params = useParams();
	const dispatch = useDispatch();
	const location = useLocation();
	const { stations } = useSelector(state => state.fmAPI);
	const { appFocusCount, userId, appUserHome } = useSelector(state => state.cdvState);

	const localFloodNavsRef = useRef(null);
	const scrollToLocalFloodNavSection = () => {
		localFloodNavsRef.current?.scrollIntoView({ behavior: 'smooth' });
	};

	let computedQualifierType = null;
	let isMissingMetrics = false;
	if(!!props.qualifierType) {
		computedQualifierType = props.qualifierType;
	} else {
		// we are in the default lookup
		computedQualifierType = "Stage"; // set sensible guess
		//nextState.stations['defaults'][action.payload.stationId] = action.payload.stationPrimaryMetricType;
		if(stations && stations.defaults && stations.defaults[params.stationId]) {
			computedQualifierType = stations.defaults[params.stationId];
		}

		if(stations && params.metricId && stations['metric-list'] && stations['metric-list'][params.stationId] && stations['metric-list'][params.stationId][params.metricId]) {
			computedQualifierType = stations['metric-list'][params.stationId][params.metricId] ? stations['metric-list'][params.stationId][params.metricId].qualifier : null;
		}

		if(stations && stations['raw-data'] && stations['raw-data'][params.stationId] && stations['raw-data'][params.stationId].qualifiers && stations['raw-data'][params.stationId].qualifiers.length === 0) {
			computedQualifierType = 'raw-data';
			isMissingMetrics = true;
		}
	}



	useEffect(() => {
		if(typeof window !== 'undefined') {
			window.scrollTo(0, 0);
		}
	}, [location]);

	useEffect(() => {
		dispatch(getStationById(params.stationId, params.metricId ? null : props.qualifierType, params.metricId));
	}, [dispatch, params.stationId, props.qualifierType, appFocusCount, params.metricId]);

	
	// TODO: We can break this component out now we have multiple station type support
	if(stations[computedQualifierType] && stations[computedQualifierType][params.stationId]) {
		let station = stations[computedQualifierType][params.stationId];
		let stationLocalMetadata = stations['station-metadata'][params.stationId];
		let metricList = stations['metric-list'] && stations['metric-list'][params.stationId] ? stations['metric-list'][params.stationId] : {};
		// let computedStationName = station.eaData && <StationNameRenderer stationName={station.eaData.eaStationLabel} qualifierType={computedQualifierType} />;
		let computedStationName = stationLocalMetadata && <StationNameRenderer stationName={stationLocalMetadata.stationName} qualifierType={computedQualifierType} />;

		let hasFloodNavs = station && station.nearByFloodNavs && station.nearByFloodNavs.length > 0;

		let riverName = stationLocalMetadata && stationLocalMetadata.riverName;
		// let stationName = station && station.eaData && station.eaData.eaStationLabel;
		let stationName = stationLocalMetadata && stationLocalMetadata.stationName;
		// let townName = stationLocalMetadata && stationLocalMetadata.townName;


		let appManagementPane = null;
		if(userId && appUserHome && station && appUserHome.metrics) {
			const matchingRecord = appUserHome.metrics.find(item => item.metricId === station.metricId);
			if(matchingRecord) {
				appManagementPane = <Row>
					<Col xs={4}><b>On your Homepage</b></Col>
					<Col xs={8}>
						<AppManageMetricsModal stationName={stationLocalMetadata.stationName} qualifierType={station.metricType} metricId={station.metricId} />
					</Col>
				</Row>;
			} else {
				appManagementPane = <Row>
					<Col xs={12} style={{marginBottom: "7px"}}>
						<AppStationSubscribe metricId={station.metricId} />
					</Col>
				</Row>;
			}
		}

		let stationRenderer = null;
		let mapViewHeaderTitle = <span>{riverName ? riverName + " at " : ""}{computedStationName}</span>;
		if(station && computedQualifierType) {
			switch(computedQualifierType) {
				case 'Sewage Discharge Live':
					stationRenderer = [<RenderStationSewageDischargeLive
						key={"includedStationPart" + station.stationId}
						isMissingMetrics={isMissingMetrics}
						station={station}
						stationName={stationName}
						computedQualifierType={computedQualifierType}
						qualifierType={props.qualifierType}
					/>];
					break;
				case 'Sewage Discharge':
					stationRenderer = [<RenderStationSewageDischarge
						key={"includedStationPart" + station.stationId}
						isMissingMetrics={isMissingMetrics}
						station={station}
						stationName={stationName}
						computedQualifierType={computedQualifierType}
						qualifierType={props.qualifierType}
					/>];
					break;
				case 'Flow':
					stationRenderer = [<RenderStationFlowBased
						key={"includedStationPart" + station.stationId}
						isMissingMetrics={isMissingMetrics}
						station={station}
						stationName={stationName}
						computedQualifierType={computedQualifierType}
						qualifierType={props.qualifierType}
					/>];
					break;
				case 'Rainfall':
					stationRenderer = [<RenderStationRainfall
						key={"includedStationPart_rf_" + station.stationId}
						isMissingMetrics={isMissingMetrics}
						station={station}
						stationName={stationName}
						computedQualifierType={computedQualifierType}
						qualifierType={props.qualifierType}
					/>];
					mapViewHeaderTitle = <span>Rainfall at {computedStationName}</span>;
					break;
				case 'WaterTemperature':
					stationRenderer = [<RenderStationTemperatureBased
						key={"includedStationPart_rf_" + station.stationId}
						isMissingMetrics={isMissingMetrics}
						station={station}
						stationName={stationName}
						computedQualifierType={computedQualifierType}
						qualifierType={props.qualifierType}
					/>];
					mapViewHeaderTitle = <span>Water Temperature at {computedStationName}</span>;
					break;
				default:
					stationRenderer = [<RenderStationLevelBased
						key={"includedStationPart" + station.stationId}
						isMissingMetrics={isMissingMetrics}
						station={station}
						stationName={stationName}
						computedQualifierType={computedQualifierType}
						qualifierType={props.qualifierType}
					/>];
					break;
			}

			if(stationRenderer && process.env.REACT_APP_ENABLE_GOOGLE_ADS === "true" && process.env.REACT_APP_ENABLE_GOOGLE_ADS_ON_STATIONS === "true") {
				stationRenderer.push(
					<Row style={{marginTop: "17px"}} key="stn_ad_cmpt">
						<Col xs={12}>
							<AdComponent
							  client="ca-pub-6790224688210339"
							  slot="5246297054"
							  format="auto"
							  responsive={true}
							/>
						</Col>
					</Row>
				);
			}
		} else {
			stationRenderer = <Loading />
		}


		let usDsCount = 0;
		if(stationLocalMetadata && stationLocalMetadata.upstreams && Array.isArray(stationLocalMetadata.upstreams)) {
			usDsCount = usDsCount + stationLocalMetadata.upstreams.length;
		}
		if(stationLocalMetadata && stationLocalMetadata.downstreams && Array.isArray(stationLocalMetadata.downstreams)) {
			usDsCount = usDsCount + stationLocalMetadata.downstreams.length;
		}

		let breadcrumbLeafs = [{
			name: "The " + stationName + " station",
			path: "/stations/" + (station.urlSlug ? station.urlSlug : station.stationId)
		}];
		let metaCanonicalUrl = "/stations/" + (station.urlSlug ? station.urlSlug : station.stationId);
		// It is a canonical w/metricId, if:
		if(station.qualifier !== station.stationPrimaryMetricType) {
			// - The qualifier is different
			switch(station.qualifier) {
				case 'Downstream Stage':
					metaCanonicalUrl += '/downstream';
					breadcrumbLeafs.push({
						name: 'Downstream',
						path: "/stations/" + (station.urlSlug ? station.urlSlug : station.stationId) + "/downstream"
					})
					break;
				case 'Rainfall':
					metaCanonicalUrl += '/rainfall';
					breadcrumbLeafs.push({
						name: 'Rainfall',
						path: "/stations/" + (station.urlSlug ? station.urlSlug : station.stationId) + "/rainfall"
					})
					break;
				case 'Flow':
					metaCanonicalUrl += '/flow';
					breadcrumbLeafs.push({
						name: 'Flow',
						path: "/stations/" + (station.urlSlug ? station.urlSlug : station.stationId) + "/flow"
					})
					break;
				case 'WaterTemperature':
					metaCanonicalUrl += '/water-temperature'
					breadcrumbLeafs.push({
						name: 'Water Temperature',
						path: "/stations/" + (station.urlSlug ? station.urlSlug : station.stationId) + "/water-temperature"
					})
					break;
				default:
					metaCanonicalUrl += "/metric/" + station.metricId;
					break;
			}
		} else {
			// - The qualifier is the same, but the metricId is not the lowest alphabetically
			const filteredAndSortedMetrics = station.metricList
			  .filter(metric => metric.qualifier === 'Sewage Discharge') // Filter by qualifier
			  .sort((a, b) => a.metricId.localeCompare(b.metricId)); // Sort by metricId

			if(filteredAndSortedMetrics.length > 0) {
				let primaryMetricId = filteredAndSortedMetrics[0].metricId;
				if(primaryMetricId !== station.metricId) {
					metaCanonicalUrl += "/metric/" + station.metricId;
				}
			}
		}


		if(mapViewHeaderTitle && station) {
			mapViewHeaderTitle = <span><GoverningBodyFlag governingBody={station.governingBody} padRight />{mapViewHeaderTitle}</span>
		}
		return <div>

			<CommonHeaders
				title={"The " + stationName + " station"}
				townName={station.placeName}
				ogType="place"
				lat={station.stationLat}
				lng={station.stationLng}
				canonicalUrlPath={metaCanonicalUrl}
				canonicalDefaultWebsite={TLDHelper.mapGoverningBodyToPrimaryWebsite(station.governingBody)}
				country={TLDHelper.mapGoverningBodyToMetaCountryName(station.governingBody)}
			/>
			<Breadcrumbs
				builtinCrumbs={[CRUMBS.HOME, CRUMBS.DATA_EXPLORER]}
				leafCrumbs={breadcrumbLeafs}
			/>
			<Row className="screen-bottom-border">
				<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-left"></Col>
				<Col xs={12} lg={10} xl={8}>
					<BreadcrumbComponent
						riverBasinName={stationLocalMetadata ? stationLocalMetadata.riverBasinName : null}
						subUnitName={stationLocalMetadata ? stationLocalMetadata.subUnitName : null}
						mgmtCatchmentName={stationLocalMetadata ? stationLocalMetadata.mgmtCatchmentName : null}
						operCatchmentName={stationLocalMetadata ? stationLocalMetadata.operCatchmentName : null}
						waterBodyName={stationLocalMetadata ? stationLocalMetadata.waterBodyName : null}
						leafText={computedStationName}
					/>
					<MapViewHeaderComponent
						key={params.stationId}
						lat={stationLocalMetadata ? stationLocalMetadata.stationLat : null}
						lng={stationLocalMetadata ? stationLocalMetadata.stationLng : null}
						isLoading={!stationLocalMetadata || !stationLocalMetadata.stationLat || !stationLocalMetadata.stationLng}
						noDefaultMarker={true}
						label={(mapViewHeaderTitle) ? mapViewHeaderTitle : "Unknown Metric"}
					>
						<StationMapMarkerComponent
							key={params.stationId + params.metricId}
							lat={station ? stationLocalMetadata.stationLat : null}
							lng={station ? stationLocalMetadata.stationLng : null}
							typicalRangeHigh={station && station.metadata ? station.metadata.typicalRangeHigh : null}
							currentHeight={station ? station.currentHeight : null}
							stationName={stationLocalMetadata ? stationLocalMetadata.stationName : null}
							riverName={station ? station.riverName : null}
							popupOpenByDefault={false}
						/>
						<StationMapMarkerLegendComponent />
						{stationLocalMetadata && stationLocalMetadata.upstreams && Array.isArray(stationLocalMetadata.upstreams) ? stationLocalMetadata.upstreams.map(function(upstreamStation, ix) {
							return <MapButtonCentralLink onClick={function() {
									sendClickStationUpstreamButton();
								}} key={"us_"+ix} position="topleft" to={"/stations/"+upstreamStation.stationId} linkText={
										<span><FMUpstreamIcon /> {upstreamStation.stationName}{upstreamStation.riverName ? <span style={{fontSize: "0.7em"}} className="d-none d-md-inline"><br className={usDsCount <= 3 ? "" : "d-none"} />({upstreamStation.riverName})</span> : ""}</span>
								} />
						}) : null}
						{stationLocalMetadata && stationLocalMetadata.downstreams && Array.isArray(stationLocalMetadata.downstreams) ? stationLocalMetadata.downstreams.map(function(downStreamStation, ix) {
							return <MapButtonCentralLink onClick={function() {
									sendClickStationDownstreamButton();
								}} key={"us_"+ix} position="bottomleft" to={"/stations/"+downStreamStation.stationId} linkText={
										<span>{downStreamStation.stationName}<span className={usDsCount <= 3 ? "" : "d-none"}> <FMDownstreamIcon /></span>{downStreamStation.riverName ? <span style={{fontSize: "0.7em"}} className="d-none d-md-inline"><br className={usDsCount <= 3 ? "" : "d-none"} />({downStreamStation.riverName})</span> : ""}<span className={usDsCount > 3 ? "" : "d-none"}> <FMDownstreamIcon /></span></span>
								} />
						}) : null}
					</MapViewHeaderComponent>
					{appManagementPane}
					{metricList && Object.keys(metricList).length > 1 ? <Row>
						<Col xs={12} style={{paddingBottom: "4px", borderBottom: "1px dashed black"}}>
							<h4 className="hX-blendin header-bold">{t('PAGES.STATION.COLLECTS_MULTI_METRIC')}</h4>
							<ButtonGroup>
								{Object.keys(metricList || {}).map(function(metricId, ix) {
									let metric = metricList[metricId];
									
									return <StationLinker
												stationId={stationLocalMetadata.stationId}
												urlSlug={stationLocalMetadata.urlSlug}
												metricQualifier={ix === 0 ? null : metric.qualifier}
												metricId={ix === 0 ? null : metricId}
											>
										<Button style={{marginLeft: "2px", marginRight: "2px"}} variant={metricId===(station ? station.metricId : "") ? "secondary" : "dark"} size="sm"><StationMetricTypeIcon qualifier={metric.qualifier} /> {metric.metricName || metric.qualifier} ({ix+1})</Button>
									</StationLinker>;
								})}
							</ButtonGroup>
						</Col>
					</Row> : null}
					{(station && hasFloodNavs) ? <Row>
						<Col xs={12} className="bg-secondary text-white">
							<Trans
						        i18nKey="PAGES.STATION.HAS_N_NEARBY_FLOODNAVS"
						        count={station.nearByFloodNavs.length}
						        components={{ b: <b />, i: <i /> }} 
						      />{"   "}<Button size="sm" variant="dark" onClick={function() {
								scrollToLocalFloodNavSection();
							}}>View</Button>
						</Col>
					</Row> : null}
					{(station && station.metadata && station.metadata.stationStatus === 'SUSPENDED') ? <Row>
						<Col xs={12}>
							<Alert variant="warning">Data for this station is currently suspended by our data provider</Alert>
						</Col>
					</Row> : null}
					{(station && station.metadata && station.metadata.stationStatus === 'CLOSED') ? <Row>
						<Col xs={12}>
							<Alert variant="danger">Our data provider has informed us that this station is <b>closed</b></Alert>
						</Col>
					</Row> : null}
					{stationRenderer}
					{/* Ads rendered via array in stationRenderer so that they change on station page change */}
					{(station && hasFloodNavs) ? <div ref={localFloodNavsRef}>
						<Row>
							<Col xs={12} className="text-white bg-dark"><b>{t('TEXT_SNIPPETS.FLOODNAV.LOCAL_FLOODNAVS')}</b></Col>
							<Col xs={12}>
								<i>{t('PAGES.STATION.MEASURE_STATION_USED_N_FLOODNAVS', { count: station.nearByFloodNavs.length })}</i>
							</Col>
							<Col xs={12}>
								<FMCoverageAreas fmCoverageAreas={station.nearByFloodNavs} enableHeader={false} />
							</Col>
						</Row>
					</div> : null}
					{(station) ? <Row>
						<Col xs={12} className="bg-dark text-white"><b>Local Information</b></Col>
					</Row> : null}
					{(station) ? <div>
						<Row>
							{(station.governingBody && ['EA', 'NRW', 'SEPA'].indexOf(station.governingBody) > -1) ? <Col xs={12} sm={6} md={4} xlg={3}>
								<ListGroup>
									<ListGroup.Item variant="dark" className="bg-dark text-white">
									{t('TEXT_SNIPPETS.FWAS.NEARBY_W_AREAS')}
									</ListGroup.Item>
									{station && station.floodAlerts ? station.floodAlerts.map(function(fa) {
										return <ListGroup.Item>
											<FloodAlertSummaryComponent key={fa.fwisCode} severityLevel={fa.severityLevel} areaName={fa.liveDescription} fwisCode={fa.fwisCode} />
										</ListGroup.Item>
									}) : null}
									{station && !station.floodAlerts  ? <ListGroup.Item><i><b>None</b></i></ListGroup.Item> : null}
								</ListGroup>
							</Col> : <Col xs={12} sm={6} md={4} xlg={3}><i>Flood Alert/Warning Areas not offered in this region</i></Col>}
							{(station.governingBody && ['EA'].indexOf(station.governingBody) > -1) ? <Col xs={12} sm={6} md={4} xlg={3}>
								<ListGroup>
									<ListGroup.Item variant="dark" className="bg-dark text-white">
									{t('TEXT_SNIPPETS.FWAS.NEARBY_A_AREAS')}
									</ListGroup.Item>
									<div>
										{station && station.floodAlertAreas ? station.floodAlertAreas.map(function(fa) {
											return <ListGroup.Item key={fa.fwisCode+"_"+fa.floodAlertAreaName}>
												<FloodAlertSummaryComponent key={fa.fwisCode} severityLevel={"4"} areaName={fa.floodAlertAreaName} fwisCode={fa.fwisCode} />
											</ListGroup.Item>
										}) : null}
										{station && !station.floodAlertAreas ? <ListGroup.Item><i><b>None</b></i></ListGroup.Item> : null}
									</div>
								</ListGroup>
							</Col> : <Col xs={12} sm={6} md={4} xlg={3}>&nbsp;</Col>}
							{(station && station.nearByStations && station.nearByStations.length > 0) ? <Col xs={12} sm={6} md={4} xlg={3}>
								<NearByStationsComponent stations={station.nearByStations} excludeId={station.stationId} headingText={t('TEXT_SNIPPETS.GENERIC_STATIONS.NEARBY', { count: 2})} upstreams={stationLocalMetadata && stationLocalMetadata.upstreams ? stationLocalMetadata.upstreams : []} downstreams={stationLocalMetadata && stationLocalMetadata.downstreams ? stationLocalMetadata.downstreams : []} />
								<NearByStationsComponent stations={station.nearByStations} excludeId={station.stationId} headingText={t('TEXT_SNIPPETS.SEWAGE_STATION.NEARBY', { count: 2 })} overrideIncludeTypes={["Sewage Discharge"]}  upstreams={stationLocalMetadata && stationLocalMetadata.upstreams ? stationLocalMetadata.upstreams : []} downstreams={stationLocalMetadata && stationLocalMetadata.downstreams ? stationLocalMetadata.downstreams : []} />
							</Col> : null}
						</Row>
					</div> : null}
					{station && station.governingBody ? <Col xs={12}>
						<Row>
							<Col xs={12} className="bg-dark text-white header-bold">Station Data Information</Col>
							<Col xs={12} style={{paddingBottom: "3px"}}>
								Station overseen (meaning either provided, or regulated) by: <GoverningBodyFlag governingBody={station.governingBody} padRight /><GoverningBodyName governingBody={station.governingBody} style={{fontWeight: "bold"}} /><br />
								The information displayed here is used under license. We are not affiliated with any governing, or other, bodies. Nor do they necessarily endorse us, or us them.<br />
								Please note that <b>FloodMapper</b> does not verify or check the accuracy of the data provided by third parties. The data is used as received from the source. Any underlying errors, inconsistencies, or inaccuracies in the original data will be reflected in the information presented on our platform. Users are advised to exercise their own judgment and caution when using the data for decision-making purposes.<br />
								Information about our data sources and licenses can be found <CentralLink to={"/copyright-information"}><Button variant="dark" size="sm">Here</Button></CentralLink>
							</Col>
						</Row>
					</Col> : null}
				</Col>
				<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-right">&nbsp;</Col>
			</Row>
		</div>;
	} else {
		return <Loading />;
	}

}

export default StationView;